/**
 * Supabase credentials are handed in by each app's entry file rather than read
 * from `import.meta.env` / `process.env` here, because Vite and Metro expose
 * env vars completely differently. Core stays platform-agnostic.
 */
export interface SupabaseConfig {
  url: string;
  publishableKey: string;
}

let config: SupabaseConfig | null = null;

export function configureSupabase(next: SupabaseConfig | null): void {
  config =
    next && next.url && next.publishableKey
      ? { url: next.url.trim(), publishableKey: next.publishableKey.trim() }
      : null;
}

export function getSupabaseConfig(): SupabaseConfig | null {
  return config;
}

/** False when the app is running with no backend — everything stays local. */
export function isCloudConfigured(): boolean {
  return config !== null;
}
